// externals
import { DateTime } from 'luxon';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// types
import type { OpenRepairOrder, OpenRepairOrderServiceLine } from '@makemydeal/dr-dash-types';

export const REPAIR_ORDER_PLACEHOLDER = '—';

export const NO_SERVICES_MESSAGE = 'No services listed for this repair order.';

/** Some feeds send a priced line with no name at all, so a bare dash would read as a rendering bug. */
export const UNNAMED_SERVICE_LABEL = 'Service name not provided';

export const formatRepairOrderCount = (count: number): string => (count === 1 ? '1 Repair Order' : `${count} Repair Orders`);

/** Falls back to the position only when the endpoint could not parse a number. */
export const formatRepairOrderNumber = ({ orderNumber }: OpenRepairOrder, index: number): string =>
    `RO# ${orderNumber?.trim() || index + 1}`;

export const formatRepairOrderDate = (date?: string): string => {
    if (!date?.trim()) {
        return REPAIR_ORDER_PLACEHOLDER;
    }

    const parsed = DateTime.fromISO(date.trim());
    return parsed.isValid ? parsed.toFormat('M/d/yyyy') : REPAIR_ORDER_PLACEHOLDER;
};

export const formatRepairOrderTotal = (total?: number): string =>
    typeof total === 'number' && Number.isFinite(total) ? formatDollarsAndCents(total) : REPAIR_ORDER_PLACEHOLDER;

export const formatServiceLabel = ({ description, nameAggregate }: OpenRepairOrderServiceLine): string =>
    description?.trim() || nameAggregate?.trim() || UNNAMED_SERVICE_LABEL;

export const formatServiceCost = ({ totalCost }: OpenRepairOrderServiceLine): string =>
    typeof totalCost === 'number' && Number.isFinite(totalCost) ? formatDollarsAndCents(totalCost) : REPAIR_ORDER_PLACEHOLDER;

export const getRepairOrderKey = ({ unifiedServiceId }: OpenRepairOrder): string => unifiedServiceId;

export const getServiceLineKey = ({ lineId }: OpenRepairOrderServiceLine, index: number): string => lineId || `line-${index}`;
